import { Spinner } from "@blueprintjs/core";
import autobind from "autobind-decorator";
import Label from "core/components/label/Label";
import { Component } from "react";
import NonIdealState from "../../../../common/fragments/NonIdealState";
import Topic from "../../entity/Topic";
import TopicComponent from "./TopicComponent";
import TopicComponentConfig from "./TopicComponentConfig";
import TopicDisplayMode from "./TopicDisplayMode";
import TopicListConfig from "./TopicListConfig";
import { isEmpty } from 'core/util/ArrayUtils';
import Query from "../../../../core/api/QueryComponent";

export interface ITopicListProps {
	listConfig: TopicListConfig;
	topicConfig: TopicComponentConfig;
	params: any;
	onTopicNavigate?: (topic: Topic, currentDepth: number, reply: boolean) => void;
	transientTopics?: Topic[]; // append for form
	mode: TopicDisplayMode;
	currentDepth?: number;
	sortParam?: string;
	pageSizeParam?: number;
	topicSearch?: string;
	pushParamAction?: (name, topic) => void;
	tagIdsParam?: number[];
	searchValue?:string;
	tagsEnabled?: boolean;
	setExcludedTopicIds?: (topicIds: number[]) => void;
	excludedTopicIds?: number[];
	showBookmarkTopics?: boolean;
	writePermision?: boolean;
	permissionFilterEnabled?: boolean;
}

export default class TopicListComponent extends Component<ITopicListProps> {
	
	constructor(props) {
		super(props);
	}

	@autobind
	private renderTopics(data: Topic[] = []) {
		const { listConfig, topicConfig, mode, onTopicNavigate, transientTopics, currentDepth, pushParamAction,setExcludedTopicIds,excludedTopicIds} = this.props;
		let topics = [];

		// problem- If user is adding New Post its appearing twice on the first load
		// adding transientTopics into topic array creating this problem

		// JCE re-enabled but only when in reply mode. this mode is does not trigger the apollo cache update, no dupes
		if (TopicDisplayMode.REPLY === mode && transientTopics) {
			topics.push(...transientTopics);
		}

		if (data) {
			topics.push(...data);
		}

		// filter out flagged topics if necessary
		// TODO do this server side

		if (listConfig.hideFlagged) {
			topics = topics.filter((t) => !t.flagged);
		}
		
		if(setExcludedTopicIds){
			let topicIds: number[] = (topics && topics.length && topics.map(t=>t.id)) || [];
			if(!this.isEqualArray(excludedTopicIds || [],topicIds))
				setExcludedTopicIds(topicIds);
		}
		if(!setExcludedTopicIds && excludedTopicIds && excludedTopicIds.length){
			topics = topics.filter(t => excludedTopicIds.indexOf(t.id)==-1);
		}
		if (this.props.showBookmarkTopics) {
			topics = topics.filter(item => item.bookmark && item.bookmark.bookmarked === true);
		}
		if (topics.length) {
			return topics.map((topic) => (
				<TopicComponent
					key={topic.id}
					config={topicConfig}
					topic={topic}
					listConfig={listConfig}
					mode={mode}
					onTopicNavigate={(topic, currentDepth: number, reply: boolean) => {
						pushParamAction("topic", topic.id)
						onTopicNavigate(topic, currentDepth, reply)
					}}
					currentDepth={currentDepth}
					tagsEnabled={this.props.tagsEnabled}
					writePermision={this.props.writePermision}
					permissionFilterEnabled={this.props.permissionFilterEnabled}
				/>
			));
		} 

		if (TopicDisplayMode.REPLY !== mode) {
			return <NonIdealState
				title={<Label k="forum.empty" v="No Posts" />}
				description={<Label k="forum.empty.desc" v="This community is empty" />}
			/>;
		}
		return null;
	}

	public render() {
		const { params, sortParam, pageSizeParam, tagIdsParam, searchValue } = this.props;

		return (
			<Query.Many entity={Topic} args={{ ...params, sort: sortParam ? sortParam : null, pageSize: pageSizeParam ? pageSizeParam : null,tagIds: tagIdsParam && tagIdsParam.length? tagIdsParam : null,query: searchValue? searchValue : null}}>
				{
					({ data, loading }) => {

						if (loading) {
							return <Spinner />;
						}

						return this.renderTopics(data);
					}
				}
			</Query.Many>
		);
	}

	private isEqualArray(arr1:number[],arr2:number[]):boolean {
		
		if(arr1.length==0 && arr2.length==0)
			return true;
		if(arr1.length != arr2.length)
			return false;
		
		if(arr1.length == arr2.length){
			if(JSON.stringify([...arr1].sort()) == JSON.stringify([...arr2].sort()))
				return true; 
		}
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/panels/forum/component/topic/TopicListComponent.tsx